import { useEffect } from 'react';

import scrollToPoint from '../scrollToPoint';

export function ScrollToTopOnMount() {
  useEffect(() => {
    scrollToPoint(0);
  }, []);
  return null;
}
